import { createContext, useContext } from 'react';

export type ModuleName = 'pilotPulse' | 'progressPulse' | 'insightPulse';

export interface EnabledModules {
  pilotPulse: boolean;
  progressPulse: boolean;
  insightPulse: boolean;
}

const DEFAULT_MODULES: EnabledModules = {
  pilotPulse: true,
  progressPulse: false,
  insightPulse: false,
};

export const ModulesContext = createContext<EnabledModules>(DEFAULT_MODULES);

export function useModules(): EnabledModules {
  return useContext(ModulesContext);
}

export function isModuleEnabled(modules: EnabledModules, name: ModuleName): boolean {
  return modules[name] === true;
}
